import { api } from '../../../lib/api'

export const PUBLISH_PRODUCT_REQUEST = 'PUBLISH_PRODUCT_REQUEST'
export const PUBLISH_PRODUCT_SUCCESS = 'PUBLISH_PRODUCT_SUCCESS'
export const PUBLISH_PRODUCT_FAILED = 'PUBLISH_PRODUCT_FAILED '

export const publishProduct = function (productId) {
  return function (dispatch) {
    dispatch({
      type: PUBLISH_PRODUCT_REQUEST
    })
    api.publishProduct(productId).then(publishProductResponse => {
      dispatch({
        type: PUBLISH_PRODUCT_SUCCESS,
        payload: publishProductResponse
      })
    }).catch(error => {
      dispatch({
        type: PUBLISH_PRODUCT_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/product/publish-product.js